import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Documento } from '../../models/Document';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { DateService } from '../../shared/date.service';
import { EstadosDocumentoComponent } from "../estados-documento/estados-documento.component";

@Component({
    selector: 'app-table-selected-documents',
    imports: [
        MatTableModule,
        EstadosDocumentoComponent
    ],
    templateUrl: './table-selected-documents.component.html',
    styleUrl: './table-selected-documents.component.scss'
})
export class TableSelectedDocumentsComponent implements OnChanges {
  @Input() documentsInformation: Documento[] = []

  displayedColumns: string[] = ['estados', 'asunto', 'fecha', 'numeroDocumento', 'para'];
  documentsDataSource = new MatTableDataSource<Documento>([])

  constructor(
    private dateService: DateService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["documentsInformation"] && this.documentsInformation) {
      this.documentsDataSource = new MatTableDataSource(this.documentsInformation)
    }
  }

  formatDate(date: string): string {
    return this.dateService.formatCustomStringToDate(date)
  }
}
